export default __webpack_public_path__ + "static/logo-nmaahc-side-text-a438a99e3e4836096a5f92f8579deaea.svg";